module.exports = __webpack_public_path__ + "37fc899a3ebc62686f21008d7e116c9f.png";